import React from 'react';
export function Footer() {
  const checkoutUrl = 'https://pay.hotmart.com/A105284571O?checkoutMode=10';
  const scrollToOffer = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <footer className="py-16 px-4 bg-card/50" data-id="element-41">
      <div className="max-w-4xl mx-auto text-center space-y-8" data-id="element-42">
        <div className="space-y-4" data-id="element-43">
          <h3 className="text-2xl md:text-3xl font-bold" data-id="element-44">
            Ya tienes las habilidades.
          </h3>
          <p className="text-xl text-gray-300" data-id="element-45">
            Ahora necesitas el sistema que las respalde.
          </p>
        </div>

        <a href={checkoutUrl} className="inline-block bg-primary hover:bg-green-600 text-white font-bold text-lg px-12 py-5 rounded-lg shadow-xl hover:shadow-2xl transition-all transform hover:scale-105" data-id="element-46">
          Conseguir el Megapack ahora
        </a>

        <div className="pt-8 border-t border-gray-700 text-sm text-gray-400" data-id="element-47">
          <p data-id="element-48">© 2024 Megapack Pádel Listo. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>;
}